// extracted by mini-css-extract-plugin
export default {"icon":"DwUzm4VESyF31PlwJjhmIA==","channelName":"UMxhB7iD--+jED2jsNDdIA=="};